import CurrentUserSettings from 'modules/Admin/settings/CurrentUser'

function SettingsCurrentUserPage() {
  return (
    <div data-testid="settingsPage">
      <CurrentUserSettings />
    </div>
  )
}

export default SettingsCurrentUserPage
